import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ExpandMoreRight from '../../../../components/Svg/ExpandMoreRight';
import styles from './TreeViewDropdownItem.module.scss';

const TreeViewDropdownItem = ({
  itemLabel,
  itemValue,
  setValue,
  onHideDropdown,
  multiple,
  parentValue,
  selected,
  children,
}) => {
  const [isSubcatoriesListShown, setIsSubcatoriesListShown] = useState(false);
  let dropdownItemStyles;

  const onHideSubcategoriesList = () => {
    setIsSubcatoriesListShown(false);
  };

  const showSubcategoriesListHandler = event => {
    event.stopPropagation();
    setIsSubcatoriesListShown(!isSubcatoriesListShown);
  };

  const categoryClickHandler = event => {
    event.stopPropagation();

    if (!multiple) {
      onHideDropdown();
      onHideSubcategoriesList();
    }
    setValue(itemValue, parentValue);
  };

  useEffect(() => {
    onHideSubcategoriesList();
  }, []);

  dropdownItemStyles = `${styles.dropdown_li} ${isSubcatoriesListShown && styles.isShown} ${
    selected && styles.selected
  }`;

  return (
    <li className={dropdownItemStyles}>
      <div className={styles.itemContainer}>
        <div
          className={styles.dropdown_li_title}
          onClick={event => {
            setIsSubcatoriesListShown(false);
            categoryClickHandler(event);
          }}
        >
          <span role="presentation">{itemLabel}</span>
        </div>
        {children && (
          <div
            onClick={event => {
              showSubcategoriesListHandler(event);
            }}
            className={isSubcatoriesListShown ? styles.iconContainerActive : styles.iconContainer}
          >
            <ExpandMoreRight isActive={isSubcatoriesListShown} />
          </div>
        )}
      </div>
      {children && isSubcatoriesListShown && <ul className={styles.bns3_dropdown_subcategory_list}>{children}</ul>}
    </li>
  );
};

TreeViewDropdownItem.propTypes = {
  itemLabel: PropTypes.string.isRequired,
  itemValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setValue: PropTypes.func.isRequired,
  onHideDropdown: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  selected: PropTypes.bool,
  parentValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
};

export default TreeViewDropdownItem;
